import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardArrowLeft as ArrowLeft,
  KeyboardArrowRight as ArrowRight,
} from "@material-ui/icons";
import Link from "components/Link";
import React, { useContext } from "react";
import useTranslation from "translations/hooks/useTranslation";
import SessionContext from "./session/SessionContext";
import Text from "./Text";
import { useMediaQuery } from "react-responsive";
import { Icon } from "@iconify/react/dist/iconify.js";

const useStyles = makeStyles((theme) => ({
  directionFlexLeft: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  directionFlexRight: {
    display: "flex",
    flexDirection: "row-reserve",
    alignItems: "center",
  },
  separator: {
    height: "15px",
    position: "relative",
    top: "2px",
    width: "16px",
    [theme.breakpoints.down("400")]: {
      top: "5px",
    },
  },
}));

export default function Breadcrumbs({ items }) {
  const classes = useStyles();
  const { t } = useTranslation();
  let mobileDimensions = { query: "(max-width: 1024px)" };
  let isMobile = useMediaQuery(mobileDimensions);

  let {
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";

  const renderSeparator = (index) => {
    return (
      index < items.length - 1 &&
      items[index + 1].text !== "" &&
      (isAr ? (
        <ArrowLeft className={classes.separator} />
      ) : (
        <ArrowRight className={classes.separator} />
      ))
    );
  };

  return (
    <div className="block text-[#ababab]">
      <div
        className={
          isAr ? classes.directionFlexRight : classes.directionFlexLeft
        }
      >
        {items?.map((item, i) => {
          if (!item?.text) return null;

          const isHome = item.text === t("home");
          const content =
            isHome && isMobile ? (
              <Icon
                className="text-disabled text-[28px]"
                icon="ic:round-home"
              />
            ) : (
              <Text
                className="truncate whitespace-pre-line text-ellipsis line-clamp-1"
                disabledColor
                text={t(item.text)}
              />
            );

          return (
            <React.Fragment key={i}>
              {item.href ? (
                <Link href={item.href}>
                  <a className="inline-flex items-center">{content}</a>
                </Link>
              ) : (
                content
              )}
              {renderSeparator(i)}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
